import { SynthBaseUI } from "./SynthUI";

export const SynthBassWamUI = ({instrument}) => {
    return (
        <SynthBaseUI instrument={instrument} synthesisParams={[["osc_detune", "osc_portamento"], ["lfo_rate", "lfo_depth"]]}/>
    )
};